import { render } from "./RequestCard.vue?vue&type=template&id=5ec58486&scoped=true"
import script from "./RequestCard.vue?vue&type=script&lang=js"
export * from "./RequestCard.vue?vue&type=script&lang=js"

import "./RequestCard.vue?vue&type=style&index=0&id=5ec58486&scoped=true&lang=css"

import exportComponent from "/Users/warths/refonte-manager-cli/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5ec58486"]])

export default __exports__